export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-axis/src/identity.js
// module id = 419
// module chunks = 0